import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { OrderHistoryItem } from '../../models';
import { PaginatedResponse } from '~shared/models';
import { ErrorResponse } from '~shared/modules/error-handler';
import { ReturnRequestPayload } from '../../models/return-request-payload.model';

export const loadOrdersList = createAction(
  '[Orders History] Load Orders History',
  props<{ params: { offset: number, limit: number } }>(),
);

export const loadOrdersListSuccess = createAction(
  '[Orders History] Load Orders History Success',
  props<PaginatedResponse<OrderHistoryItem>>(),
);

export const loadOrder = createAction(
  '[Orders History] Load Orders History Item',
  props<{ orderId: string }>(),
);

export const loadOrderSuccess = createAction(
  '[Orders History] Load Orders History Item Success',
  props<{ order: Update<OrderHistoryItem> }>(),
);

export const clearOrdersList = createAction(
  '[Orders History] Clear Orders History List',
);

export const cancelOrder = createAction(
  '[Orders History] Cancel Order History Item',
  props<{ orderId: string }>(),
);

export const cancelReturnOrder = createAction(
  '[Orders History] Cancel Return Order History Item',
  props<{ orderId: string, orderLineIds: string[] }>(),
);

export const cancelOrderLine = createAction(
  '[Orders History] Cancel OrderLine History Item',
  props<{ payload: { orderId: string, orderLineId: string, } }>(),
);

export const cancelOrderLineReturnRequest = createAction(
  '[Orders History] Cancel OrderLine Return History Item Request',
  props<{ payload: { orderId: string, orderLineId: string } }>(),
);

export const returnOrder = createAction(
  '[Orders History] Return Order History Item',
  props<{ orderId: string, orderLineIds: string[], returnReason: string }>(),
);

export const returnOrderLineRequest = createAction(
  '[Orders History] Return OrderLine History Item Request',
  props<{ payload: ReturnRequestPayload }>(),
);

export const orderHistoryFailure = createAction(
  '[Orders History] Order History Failure',
  props<{ error: ErrorResponse }>(),
);
